<h2>Employees</h2>
<div class="form-well">
    <ng-container *ngIf="showButtons">
        <div class="btn-group" role="group">
            <button (click)="showAdd()" type="submit" class="btn btn-primary align-middle">
                Add Employee
                <fa-icon class="ms-2" [icon]="faPlusSign"></fa-icon>
            </button>
            <button (click)="showImportView()" type="submit" class="btn btn-secondary">
                Import <fa-icon class="ms-2" [icon]="faUpload"></fa-icon>
            </button>
        </div>
    </ng-container>
    <form *ngIf="isAdd || isEdit" class="formly" role="form" [formGroup]="form" (ngSubmit)="process(employee)">
        <h3>
            <ng-container *ngIf="isAdd">Add</ng-container>
            <ng-container *ngIf="isEdit">Edit</ng-container>
        </h3>
        <formly-form [model]="employee" [fields]="fields" [form]="form">
        </formly-form>
        <div class="btn-group" role="group">
            <button type="submit" class="btn btn-primary" [disabled]="form.invalid">
                Save
            </button>
            <button type="button" (click)="saveAndNew()" [disabled]="form.invalid" *ngIf="!isEdit"
                class="btn btn-success">
                Save &amp; New
            </button>
            <button type="reset" (click)="cancel()" class="btn btn-secondary">
                Close
            </button>
        </div>
    </form>
    <form *ngIf="showImport" class="formly" role="form" [formGroup]="form" (ngSubmit)="uploadFile()">
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <p><strong>Step 1</strong> - Add or Update Employees</p>
                    <p>
                        Download the spreadsheet. The following columns are
                        mandatory: Employee Number, First Name, Last Name, Role,
                        and Type
                    </p>
                    <p>Dates need to be formatted as yyyy-MM-dd</p>
                    <div class="checkbox form-control">
                        <label>
                            <input type="checkbox" [(ngModel)]="downloadWithData"
                                [ngModelOptions]="{ standalone: true }" />
                            Pre-populate with existing employees
                        </label>
                    </div>
                    <a href="/api/settings/employees/download/{{
                            downloadWithData
                        }}" class="btn btn-secondary ms-lg-2 mt-xs-2">Download
                        <fa-icon class="ms-2" [icon]="faDownload"></fa-icon></a>
                </div>
                <div class="mb-3">
                    <p><strong>Step 2</strong> - Upload the updated csv file</p>
                    <input type="file" class="form-control" (change)="fileChangeEvent($event)" />
                </div>
                <div class="mb-3">
                    <div class="btn-group" role="group">
                        <button type="submit" class="btn btn-primary" [disabled]="!uploadableFile">
                            Upload
                        </button>
                        <button type="reset" (click)="cancel()" class="btn btn-secondary">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>